import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import styled from "styled-components";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import RelatorioMsl from "./Components/Relatorio";
import { useSelections } from "../../context/Selections";
import NativeFilter from "../../components/NativeFilter/NativeFilter";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "94%",
  justifyContent: "flex-start",
  width: "100%",
});

function MslDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Overview");
  const [selectedValueBatalha, setSelectedValueBatalha] = useState("TRAD");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const handleChange = (event) => {
    app.field("Desc_MSL").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  const handleChangeBatalha = (event) => {
    app.field("Desc_Batalha").selectMatch(event.target.value, true);
    setSelectedValueBatalha(event.target.value);
  };

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s?.qField === "Desc_MSL")
        : null;
      setSelectedValue(distributors?.qSelected);
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors?.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s?.qField === "Desc_Batalha")
        : null;
      setSelectedValueBatalha(distributors?.qSelected);
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors?.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  return (
    <div className="app Msl">
      <div className="appContent">
        <div className="container-form-filtro">
          <FormControl className="container-form-control">
            <RadioGroup
              defaultValue="Overview"
              row
              name="row-radio-buttons-group"
              className="radio-group radio-group-button-export"
              value={selectedValue}
              onChange={handleChange}
              sx={{ marginLeft: "20px" }}
            >
              <FormControlLabel
                value="Overview"
                control={
                  <Radio
                    size="small"
                    defaultChecked
                    sx={{
                      color: "#ff007f",
                      "&.Mui-checked": {
                        color: "#dd007f",
                      },
                    }}
                  />
                }
                label="Overview"
              />

              <FormControlLabel
                value="Relatórios"
                control={
                  <Radio
                    size="small"
                    sx={{
                      color: "#ff007f",
                      "&.Mui-checked": {
                        color: "#dd007f",
                      },
                    }}
                  />
                }
                label="Relatórios"
              />

              <FormControlLabel
                value="Batalha Naval"
                control={
                  <Radio
                    size="small"
                    sx={{
                      color: "#ff007f",
                      "&.Mui-checked": {
                        color: "#dd007f",
                      },
                    }}
                  />
                }
                label="Batalha Naval"
              />

              <FormControlLabel
                value="Oportunidade"
                control={
                  <Radio
                    size="small"
                    sx={{
                      color: "#ff007f",
                      "&.Mui-checked": {
                        color: "#dd007f",
                      },
                    }}
                  />
                }
                label="Oportunidade"
              />
            </RadioGroup>
          </FormControl>

          <card style={{ height: "100%" }}>
            <NativeFilter
              key={"StpHBGm"}
              app={app}
              style={{
                height: "35px",
                width: "207px",
                marginRight: "6px",
              }}
              reference={{ label: "Mes Ano", id: "StpHBGm" }}
            />
          </card>
        </div>

        {selectedValue === "Overview" && (
          <>
            <LayoutCardsWrapper>
              <Grid container rowGap={2} height={"40%"}>
                <LayoutCardWrapper style={{ paddingLeft: "10px" }}>
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Evolução Anual: ",
                    }}
                    exportTable
                    exportTableId="mueZTzp"
                    style={{ width: "100%", height: "100%" }}
                    className={"container-table"}
                  >
                    <NativeObject
                      app={app}
                      key="mueZTzp"
                      reference={{ id: "mueZTzp" }}
                    />
                  </Card>
                </LayoutCardWrapper>
              </Grid>
              <Grid
                container
                rowGap={2}
                justifyContent={"space-between"}
                marginTop={"16px"}
                paddingLeft={"10px"}
                height={"55%"}
                className="container-row-objects"
              >
                <Grid item className="item-objects-msl-second">
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Ranking Regional ",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      className={"container-table"}
                    >
                      <NativeObject
                        app={app}
                        key="fwZszp"
                        reference={{ id: "fwZszp" }}
                        className={"objetct"}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>

                <Grid item className="item-objects-msl-second">
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Ranking Marcas ",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      className={"container-table"}
                    >
                      <NativeObject
                        app={app}
                        key="BNxuWzT"
                        reference={{ id: "BNxuWzT" }}
                        className={"objetct"}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>

                <Grid item className="item-objects-msl-second">
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Ranking DBs ",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      className={"container-table"}
                    >
                      <NativeObject
                        app={app}
                        key="QmJyGF"
                        reference={{ id: "QmJyGF" }}
                        className={"objetct"}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>
              </Grid>
            </LayoutCardsWrapper>
          </>
        )}

        {selectedValue === "Relatórios" && (
          <RelatorioMsl app={app} config={config} />
        )}

        {selectedValue === "Batalha Naval" && (
          <>
            <div>
              <h2 className="container-title">Visão: </h2>
              <div className="container-grup-radios-filter">
                <FormControl className="container-form-control">
                  <RadioGroup
                    defaultValue="TRAD"
                    row
                    name="row-radio-buttons-group"
                    className="radio-group radio-group-button-export"
                    value={selectedValueBatalha}
                    onChange={handleChangeBatalha}
                    sx={{ marginLeft: "20px" }}
                  >
                    <FormControlLabel
                      value="TRAD"
                      control={
                        <Radio
                          size="small"
                          defaultChecked
                          sx={{
                            color: "#ff007f",
                            "&.Mui-checked": {
                              color: "#dd007f",
                            },
                          }}
                        />
                      }
                      label="TRAD"
                    />

                    <FormControlLabel
                      value="INDEP"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            color: "#ff007f",
                            "&.Mui-checked": {
                              color: "#dd007f",
                            },
                          }}
                        />
                      }
                      label="INDEP"
                    />

                    <FormControlLabel
                      value="SUPER P"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            color: "#ff007f",
                            "&.Mui-checked": {
                              color: "#dd007f",
                            },
                          }}
                        />
                      }
                      label="SUPER P"
                    />

                    <FormControlLabel
                      value="SUPER G"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            color: "#ff007f",
                            "&.Mui-checked": {
                              color: "#dd007f",
                            },
                          }}
                        />
                      }
                      label="SUPER G"
                    />

                    <FormControlLabel
                      value="C&C"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            color: "#ff007f",
                            "&.Mui-checked": {
                              color: "#dd007f",
                            },
                          }}
                        />
                      }
                      label="C&C"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            <LayoutCardsWrapper>
              <Grid container rowGap={2} height={"100%"}>
                <LayoutCardWrapper style={{ paddingLeft: "10px" }}>
                  <Card
                    app={app}
                    exportTable
                    exportContainer
                    exportTableId="bgPTxs"
                    style={{ width: "100%", height: "100%" }}
                    className={"container-table"}
                  >
                    <NativeObject
                      app={app}
                      key="bgPTxs"
                      reference={{ id: "bgPTxs" }}
                    />
                  </Card>
                </LayoutCardWrapper>
              </Grid>
            </LayoutCardsWrapper>
          </>
        )}

        {selectedValue === "Oportunidade" && (
          <LayoutCardsWrapper>
            <Grid container rowGap={2} height={"100%"}>
              <LayoutCardWrapper style={{ paddingLeft: "10px" }}>
                <Card
                  app={app}
                  exportTable
                  exportContainer
                  exportTableId="YGLB"
                  style={{ width: "100%", height: "100%" }}
                  className={"container-table"}
                >
                  <NativeObject
                    app={app}
                    key="YGLB"
                    reference={{ id: "YGLB" }}
                  />
                </Card>
              </LayoutCardWrapper>
            </Grid>
          </LayoutCardsWrapper>
        )}
      </div>
    </div>
  );
}

MslDesktop.defaultProps = {
  app: null,
  config: {},
};

MslDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default MslDesktop;
